module.exports = __webpack_public_path__ + "public/img/banner.20178e55.jpg";